<script setup>
import Tag from 'primevue/tag';
import { computed } from 'vue'

const props = defineProps({
  transferee: {
    required: true, 
    type: [Object, null], 
    default: {}
  },
})

const status  = computed(() => props.transferee.status )
const isActive  = computed(() => !!props.transferee.isActive)
const isClosed = computed(() => !!props.transferee.isClosed)
</script>

<template lang="pug">
Tag(v-if="isActive" :value="status" severity="info" rounded) 
Tag(v-else-if="isClosed" :value="status" severity="warn" rounded) 
Tag(v-else :value="status" severity="secondary" rounded) 
</template>